export const normalizeImportField = (value) => String(value ?? '').trim();
